import axiosInstance from "../utils/api";

import endpoints from "../constants/endpoints";



export const ClientPaymentAndOrderApi = {

    fetchProductAvailablePropertiesBeforeCheckout: async (productId) => {
        try {
            const response = await axiosInstance.get(endpoints.fetch_product_available_specification_for_checkout(productId));
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    priceCalculatorBeforeCheckout: async (productId, formData) => {
        try {
            const response = await axiosInstance.post(endpoints.priceCalculatorBeforeCheckout(productId), formData);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    fetchProjectDetail: async (projectId) => {
        try {
            const response = await axiosInstance.get(endpoints.fetchCustomizedProductDesignDetail(projectId));
            return response.data;
        } catch (error) {
            throw error;
        }
    }
    ,
    fetchProductDetail: async (productId) => {
        try {
            const response = await axiosInstance.get(endpoints.fetchSingleProductDetail(productId));
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    submitOrder: async (orderData) => {
        try {
            const response = await axiosInstance.post(endpoints.createOrder, orderData);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    addShippingAddress: async (shippingAddressData) => {
        try {
            const response = await axiosInstance.post(endpoints.addShippingAddress, shippingAddressData);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    toggleShippingAddressStatus: async (shippingAddressId) => {
        try {
            const response = await axiosInstance.post(endpoints.toggleSippingAddressStatus(shippingAddressId));
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    getPaymentDetailAfterPayment: async (transactionId) => {
        try {
            const response = await axiosInstance.get(endpoints.fetchPaymentDetailAfterPayment(transactionId));
            return response.data;
        } catch (error) {
            throw error;
        }
    }

};